import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { IonicModule } from "ionic-angular";
import { CostsControlComponent } from "./costs-control.component";

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        TranslateModule.forChild()
    ],
    declarations: [
        CostsControlComponent
    ],
    exports: [
        CostsControlComponent
    ]
})
export class CostsControlModule {

}



// WEBPACK FOOTER //
// ./src/vas/controls/costs/form/costs-control.module.ts